<i18n src="@/translations/FinGreeting.json"></i18n>

<template>
  <v-row :class="$valueByBreakpoint({xs: 'mobile', md:'medium', lg:'widescreen' })" no-gutters>
    <v-col cols="2" :style="`min-width: 255px; margin-left: -80px; margin-right: -60px`" v-if="profileArchetype">
      <fin-archetype-illustration :archetype="profileArchetype"
                                  :height="$valueByBreakpoint({xs:90, md:131})"
                                  animate hide-scene/>
    </v-col>
    <v-col :class="`greeting pt-0 ${profileArchetype || 'ml-10 mb-10'}`">
      <!-- here v-row v-col to be able to align the help center info nearer to this content-->
      <v-row dense>
        <v-col cols="auto" class="greeting-helpcenter-info px-3">
          {{ $t('hello') }}
          <fin-current-user-name/>
          <span v-if="$vuetify.breakpoint.mdAndUp">, <br/>{{ $t('welcome_to_company_name') }} </span>

          <div class="archetype-presentation" v-if="profileArchetype">
            {{ $t('FinGreeting.you_are_archetype_type') }}: <span class="bold">{{ profileArchetype.title }}</span>
          </div>

          <v-expansion-panels v-if="$vuetify.breakpoint.smAndUp" class="mt-3" flat style="max-width: 400px;">
            <v-expansion-panel>
              <v-expansion-panel-header class="pa-0 contact-header">
                <v-icon :size="24" class="mr-3" style="flex: none;">icon-conversation</v-icon>
                <span style="font-weight: bold; flex: none;" v-html="$t('contact')"/>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="contact" style="font-size: 14px;">
                <p class="mb-0 contact-text">
                  {{ $t('you_have_questions_or_issues') }}<br/>
                  {{ $t('please_contact_our_support') }} <a href="mailto:support@fincraft.de">support@fincraft.de</a>.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import FinCurrentUserName from '@/components/auth/CurrentUserName'
import {mapGetters} from "vuex"
import FinArchetypeIllustration from "@/components/pages/onboarding/ArchetypeIllustration/index"

export default {
  name: 'FinGreeting',
  components: {FinArchetypeIllustration, FinCurrentUserName},
  computed: {
    ...mapGetters('auth', ['profileArchetype']),
  },
}
</script>

<style lang="scss" scoped>
.greeting {
  font-family: Tiempos;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.23;

  .medium &, .widescreen & {
    font-size: 28px;
    line-height: 1.2;
  }

  ::v-deep .contact .v-expansion-panel-content__wrap {
    padding: 0;
  }

  ::v-deep .contact-header .v-expansion-panel-header__icon {
    margin-left: 12px;
  }

  .contact-text {
    color: $fin-color-primary-dark;
  }
}

.archetype-presentation {
  font-family: Gilroy;
  font-size: 14px;
  line-height: 1.5;

  .bold {
    font-weight: 600;
  }
}
</style>
